import React from 'react';

const IVRSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="30" height="30">
    <defs>
      <linearGradient id="phoneGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#4285f4" />
        <stop offset="100%" stopColor="#3367d6" />
      </linearGradient>
      <linearGradient id="nodeGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#34a853" />
        <stop offset="100%" stopColor="#2d9247" />
      </linearGradient>
    </defs>

    {/* Phone receiver at top (root) */}
    <rect x="24" y="4" width="16" height="12" rx="2" fill="url(#phoneGrad)" stroke="#2c5aa0" strokeWidth="1.5" />

    {/* Speaker lines */}
    <g opacity="0.4">
      <line x1="27" y1="8" x2="37" y2="8" stroke="white" strokeWidth="1" strokeLinecap="round" />
      <line x1="27" y1="12" x2="37" y2="12" stroke="white" strokeWidth="1" strokeLinecap="round" />
    </g>

    {/* Tree structure lines */}
    <g stroke="#7c8a9d" strokeWidth="2" fill="none" opacity="0.7">
      {/* Main trunk from phone */}
      <line x1="32" y1="16" x2="32" y2="26" />

      {/* First level branches */}
      <line x1="32" y1="26" x2="16" y2="36" />
      <line x1="32" y1="26" x2="32" y2="36" />
      <line x1="32" y1="26" x2="48" y2="36" />

      {/* Second level branches from left node */}
      <line x1="16" y1="36" x2="10" y2="46" />
      <line x1="16" y1="36" x2="22" y2="46" />

      {/* Second level branches from right node */}
      <line x1="48" y1="36" x2="42" y2="46" />
      <line x1="48" y1="36" x2="54" y2="46" />
    </g>

    {/* First level nodes */}
    <circle cx="16" cy="36" r="5" fill="url(#nodeGrad)" stroke="#2d9247" strokeWidth="1.5" />
    <circle cx="32" cy="36" r="5" fill="url(#nodeGrad)" stroke="#2d9247" strokeWidth="1.5" />
    <circle cx="48" cy="36" r="5" fill="url(#nodeGrad)" stroke="#2d9247" strokeWidth="1.5" />

    {/* Node numbers */}
    <text x="16" y="39" fontSize="8" fill="white" fontWeight="bold" textAnchor="middle" fontFamily="Arial">
      1
    </text>
    <text x="32" y="39" fontSize="8" fill="white" fontWeight="bold" textAnchor="middle" fontFamily="Arial">
      2
    </text>
    <text x="48" y="39" fontSize="8" fill="white" fontWeight="bold" textAnchor="middle" fontFamily="Arial">
      3
    </text>

    {/* Second level leaf nodes (smaller) */}
    <circle cx="10" cy="56" r="4" fill="#ff6b6b" stroke="#e74c3c" strokeWidth="1.5" />
    <circle cx="22" cy="56" r="4" fill="#ff6b6b" stroke="#e74c3c" strokeWidth="1.5" />
    <circle cx="42" cy="56" r="4" fill="#ff6b6b" stroke="#e74c3c" strokeWidth="1.5" />
    <circle cx="54" cy="56" r="4" fill="#ff6b6b" stroke="#e74c3c" strokeWidth="1.5" />

    {/* Shine on phone */}
    <ellipse cx="28" cy="8" rx="3" ry="4" fill="white" opacity="0.3" />
  </svg>
);

export default IVRSvg;
